import styled from 'styled-components'

import { StyledTooltipProp } from './interface'

export const RemoveButton = styled.button`
  display: block;
  background-color: transparent;
  width: 24px;
  height: 24px;
  border: 0;
  position: relative;
  cursor: pointer;
`

export const Tooltip = styled.span<StyledTooltipProp>`
  width: inherit;
  height: inherit;
  position: relative;
  display: inline-block;

  &:hover {
    &:before,
    &:after {
      display: inline-block;
    }
  }

  :before {
    content: '${({ description }) => description}';
    display: none;
    background-color: ${({ theme }) => theme.colors.mainSecondaryDark};
    color: ${({ theme }) => theme.colors.graysWhite};
    text-align: center;
    white-space: nowrap;
    padding: 16px;
    border-radius: 16px;
    transform: translate(40px, 20px);
    z-index: 1;
    position: absolute;
    right: 0;
    top: 90%;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: bold;
    z-index: 2;
  }

  :after {
    content: '';
    display: none;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 9px;
    border-style: solid;
    border-color: transparent transparent
      ${({ theme }) => theme.colors.mainSecondaryDark} transparent;
  }

  > svg {
    z-index: 1;
  }
`
